
import { DropDownOptions } from "devextreme-react/drop-down-box";
import Form, { GroupItem, SimpleItem } from "devextreme-react/form";
import { forwardRef, useCallback, useEffect, useState } from "react";
import { useSelector } from "react-redux";
import { DropDownGrid } from "../../components";
import { getApiParams } from "../../redux/auth";
import { BodyType, createRequest } from "../../redux/base/request";
import { ApiResponse, verfiyResponse } from "../../redux/base/types/saga";
import { getLocalized } from "../../redux/localization";
import { Account} from "../account/types";
import { AccountCallLogStatus } from "../callStatus/type";
import { SendAccountCallLog } from "./type";


export const CreateAccountCallLog = forwardRef<any, { data: SendAccountCallLog }>((
    { data}, ref
) => {
    const [, setId] = useState();
    const [, setId1] = useState();
    const [accounts, setAccounts] = useState<Account[]>([]);
    const [callLogStatusTypes, setCallLogStatusTypes] = useState<AccountCallLogStatus[]>([]);
    const localize = useSelector(getLocalized);
    const { token, lang } = useSelector(getApiParams);
    const getAccounts = useCallback((async () => {
        const response: ApiResponse<Account[]> = await createRequest({
            method: "GET",
            url: "/api/admin/accounts",
            bodyType: BodyType.formdata,
            token,
            body: {},
            lang,
        });
        if (verfiyResponse(response)) {
            setAccounts(response.Result)
        }
    }), [token, lang])

    const getCallStatusTypes = useCallback((async () => {
        const response: ApiResponse<AccountCallLogStatus[]> = await createRequest({
            method: "GET",
            url: "/api/admin/adminaccountcalllogstatuses",
            bodyType: BodyType.formdata,
            token,
            body: {},
            lang,
        });
        if (verfiyResponse(response)) {
            setCallLogStatusTypes(response.Result)
        }
    }), [token, lang])

    useEffect(() => {
        getAccounts()
        getCallStatusTypes()
    }, [getAccounts,getCallStatusTypes])
    return <Form
        formData={data}
        ref={ref}
    >
        <GroupItem>
            <SimpleItem
                dataField={"AccountId"}
                editorType="dxLookup"
                label={{ text: localize.getString("account") }}
                render={(item: any) => (
                    <DropDownGrid
                        dataSource={accounts}
                        columns={[
                            {
                                dataField: "AccountName",
                                caption: localize.getString("accountName"),

                            },
                            {
                                dataField: "AccountType",
                                caption: localize.getString("accounttype"),

                            },
                            {
                                dataField: "CreateTime",
                                caption: localize.getString("creationtime"),
                                dataType: "date"
                            },
                            {
                                dataField: "Phone",
                                caption: localize.getString("phone"),

                            },
                        ]}
                        displayExpr="AccountName"
                        returnSelectedId={async (id: any) => {
                            item.editorOptions.value = id;
                            data.AccountId = id;
                            setId(id);
                        }}

                        value={data.AccountId}
                        dropDownOptions={{ width: 900 }} />

                )}
            >

                <DropDownOptions closeOnOutsideClick showTitle={false} />
            </SimpleItem>
            <SimpleItem
                dataField={"TalkedWith"}
                editorType={"dxTextBox"}
                label={{
                    text: localize.getString("talkedWidth")
                }}
            >

            </SimpleItem>
            <SimpleItem
                dataField={"AccountCallLogStatusId"}
                editorType={"dxLookup"}
                render={(item: any) => (
                    <DropDownGrid
                        dataSource={callLogStatusTypes}
                        columns={["Name"]}
                        displayExpr="Name"
                        returnSelectedId={async (id: any) => {
                            console.log(id)
                            item.editorOptions.value = id;
                            data.AccountCallLogStatusId = id
                            setId1(id);
                        }}
                        value={data.AccountCallLogStatusId}
                        dropDownOptions={{ width: 500 }} />
                )}
                label={{
                    text: localize.getString("callStatus")
                }}
            >
            </SimpleItem>
            <SimpleItem
                dataField={"Note"}
                editorType={"dxTextArea"}
                label={{
                    text: localize.getString("note")
                }}
            >

            </SimpleItem>


            <SimpleItem
                dataField={"NextCallDate"}
                editorType="dxDateBox"
                editorOptions={{
                    dateSerializationFormat: "yyyy-MM-dd"
                }}
                label={{
                    text: localize.getString("nextCallDate")
                }}

            >

            </SimpleItem>
            <SimpleItem
                dataField={"NextCallNote"}
                editorType={"dxTextBox"}
                label={{
                    text: localize.getString("nextCallNote")
                }}
            >

            </SimpleItem>

        </GroupItem>
    </Form >
})